import ApiConnect from "./ApiConnect";

export class DataCenter
{
    public static getSubjects(callback: Function) {
        let apiConnect: ApiConnect = new ApiConnect();
        apiConnect.Send(106, callback);
    }

    public static getTree(subjectID:number,callback:Function)
    {
        const apiConnect:ApiConnect=new ApiConnect();
        apiConnect.addParam(subjectID.toString());
        apiConnect.Send(98,callback);
    }
    public static getTriedGames(userCode:string,subjectID:number,callback:Function)
    {
        const apiConnect:ApiConnect=new ApiConnect();
        apiConnect.addParam(userCode);
        apiConnect.addParam(subjectID.toString());
        apiConnect.Send(1704,callback);
    }
    //get unlocks
    public static getUnlocks(userCode:string,subjectID:number,callback:Function)
    {
        const apiConnect:ApiConnect=new ApiConnect();
        apiConnect.addParam(userCode);
        apiConnect.addParam(subjectID.toString());
        apiConnect.Send(226,callback);
    }
    public static getUserInfo(callback: Function, userCode: string) {
        let apiConnect: ApiConnect = new ApiConnect();
        apiConnect.addParam(userCode);
        apiConnect.Send(1701, callback);
    }
    //get games played 235
    public static getGamesPlayed(userCode:string,subjectID:number,callback:Function)
    {
        const apiConnect:ApiConnect=new ApiConnect();
        apiConnect.addParam(userCode);
        apiConnect.addParam(subjectID.toString());
        apiConnect.Send(235,callback);
    }
    //get topics completed 236
    public static getTopicsCompleted(userCode:string,subjectID:number,callback:Function)
    {
        const apiConnect:ApiConnect=new ApiConnect();
        apiConnect.addParam(userCode);
        apiConnect.addParam(subjectID.toString());
        apiConnect.Send(236,callback);
    }
}